import { type Registry as Services, service } from '@ember/service';
import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import {
  NUMBER_FORMATS,
  NUMBER_STYLES,
} from 'lumen/utils/constants/benchmark-insight/beni-constant-values';

export default class BeniBreakdownPeriodSegmentPickup extends Model {
  [Type] = 'benchmark-insight/breakdown-period-segment-pickup' as const;

  @attr('number') declare adr: number | null;
  @attr('number') declare occupancy: number | null;
  @attr('number') declare occupancyMix: number | null;
  @attr('number') declare pickupDays: number;
  @attr('number') declare revpar: number | null;

  @service('benchmark-insight/beni-service')
  declare benchmarkInsightBeniService: Services['benchmark-insight/beni-service'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedAdr() {
    return this.benchmarkInsightBeniService.formatNumber(
      this.adr,
      NUMBER_FORMATS.CURRENCY,
      NUMBER_STYLES.CHANGE,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedOccupancy() {
    return this.benchmarkInsightBeniService.formatNumber(
      this.occupancy,
      NUMBER_FORMATS.PERCENTAGE,
      NUMBER_STYLES.CHANGE,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedOccupancyMix() {
    return this.benchmarkInsightBeniService.formatNumber(
      this.occupancyMix,
      NUMBER_FORMATS.PERCENTAGE,
      NUMBER_STYLES.CHANGE,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedRevpar() {
    return this.benchmarkInsightBeniService.formatNumber(
      this.revpar,
      NUMBER_FORMATS.CURRENCY,
      NUMBER_STYLES.CHANGE,
    );
  }
}
